import { api } from '../../libs/api'
import dateToDateString from '../../libs/date-to-date-string'

export default {
  namespaced: true,

  state: {
    index: [],
    errors: [],
    condition: {},
    modal: {
      showJobNotificationSettingModal: false,
    },
  },
  getters: {
    humanizedIndex: (state, _a, _b, rootGetters) =>
      state.index.map(({ id, name, search_condition: condition, updated_at: updatedAt, monday, tuesday, wednesday, thursday, friday, saturday, sunday, time, lower_limit_count: lowerLimitCount }) => {
        const {
          mediaCd,
          prefectureCd,
          cityCd,
          workPlacePrefectureCd,
          workPlaceCityCd,
          industryCd,
          viewEndDate,
          acquisitionDate,
        } = condition

        return {
          id,
          name,
          media: rootGetters['master/translateList']('media', mediaCd),
          prefectures: rootGetters['master/translateList']('prefectures', prefectureCd),
          cities: rootGetters['master/translateList']('cities', cityCd),
          workPlacePrefectures: rootGetters['master/translateList']('prefectures', workPlacePrefectureCd),
          workPlaceCities: rootGetters['master/translateList']('cities', workPlaceCityCd),
          industries: rootGetters['master/translateList']('industries', industryCd),
          situation: rootGetters['master/translate']('postingSituations', viewEndDate),
          acquisitionDate: rootGetters['master/translate']('acquisitionDates', acquisitionDate),
          condition,
          updatedAt: dateToDateString(new Date(updatedAt)),
          monday,
          tuesday,
          wednesday,
          thursday,
          friday,
          saturday,
          sunday,
          time: new Date(time),
          lowerLimitCount,
        }
      }),
    condition: state => state.condition,
    sending: state => state.modal.showJobNotificationSettingModal,
    list: state => state.index.map(({ id, name }) => ({ id, name })),
  },
  mutations: {
    index: (state, index) => state.index = index,
    errors: (state, errors) => state.errors = errors,
    condition: (state, condition) => state.condition = condition,
    showJobNotificationSettingModal: state => state.modal.showJobNotificationSettingModal = true,
    hideJobNotificationSettingModal: state => state.modal.showJobNotificationSettingModal = false,
  },
  actions: {
    async fetchIndex ({ commit }) {
      try {
        commit('index', await api.fetchMyJobNotificationSettingIndex())
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async setConditions ({ commit }, { condition }) {
      commit('condition', condition)
    },
    async send ({ commit }, { name, condition, monday, tuesday, wednesday, thursday, friday, saturday, sunday, hour, minutes, lowerLimitCount, id }) {
      try {
        if (id) {
          await api.updateJobNotificationSetting({
            id,
            name,
            condition,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
            hour,
            minutes,
            lowerLimitCount,
          })
        } else {
          await api.createJobNotificationSetting({
            name,
            condition,
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday,
            hour,
            minutes,
            lowerLimitCount,
          })
        }
      } catch (e) {
        commit('errors', e)
        return Promise.reject(e)
      }
    },
    async destroy ({ dispatch }, { id }) {
      try {
        await api.destroyJobNotificationSetting({ id })
        await dispatch('fetchIndex')
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/jobNotificationSetting.js